/**
 * Preload images
 */
export const preloadImages = (imageUrls) => {
  return Promise.all(
    imageUrls.map((url) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(url);
        img.onerror = () => reject(url);
        img.src = url;
      });
    })
  );
};

/**
 * Preload all assets with progress tracking
 */
export const preloadAssets = async (assets, onProgress) => {
  const totalAssets = assets.length;
  let loadedAssets = 0;

  const promises = assets.map((asset) => {
    return new Promise((resolve) => {
      if (asset.endsWith('.mp4') || asset.endsWith('.webm')) {
        // Skip videos
        loadedAssets++;
        if (onProgress) {
          onProgress((loadedAssets / totalAssets) * 100);
        }
        resolve();
      } else {
        // Load images
        const img = new Image();
        img.onload = () => {
          loadedAssets++;
          if (onProgress) {
            onProgress((loadedAssets / totalAssets) * 100);
          }
          resolve();
        };
        img.onerror = () => {
          loadedAssets++;
          if (onProgress) {
            onProgress((loadedAssets / totalAssets) * 100);
          }
          resolve(); // Resolve even on error to not block loading
        };
        img.src = asset;
      }
    });
  });

  await Promise.all(promises);
};

/**
 * Wait for fonts to load
 */
export const waitForFonts = async () => {
  if (document.fonts && document.fonts.ready) {
    await document.fonts.ready;
  }
};
